import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import './PerfilInvestidor.scss';

class PerfilInvestidor extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();
	}

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Pesquisa Raio X do Investidor Brasileiro - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="perfil-investidor-home page-gradient page-gradient--yellow bg-gray" ref="perfil-investidor-home">

          <section className="perfil-investidor-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink to="/estrategias/para-o-mercado" className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">Pesquisa Raio X <br />do Investidor Brasileiro</h1>
                        </div>
                        <div className="card__content__body">
                          <p>Realizamos a segunda edição da pesquisa, em parceria com o Datafolha. O objetivo do estudo é acompanhar ano a ano os hábitos do investidor brasileiro: se guarda dinheiro, no que investe, o que considera na hora de aplicar, como se planeja para o futuro, entre outros aspectos. </p>
													<p>O levantamento mostrou que 42% dos brasileiros tinham algum saldo em produtos de investimento em 2018 – mesma porcentagem de 2017. Entre os 33% que economizaram no ano, 48% investiram em produtos financeiros – um aumento de seis pontos em relação ao ano anterior. A poupança ainda é a preferência nacional na hora de aplicar: 88% dos aportes feitos em 2018 ficaram na caderneta, seguida com distância pela previdência privada (6%), títulos privados (5%) e fundos (4%).</p>
													<p>
														Os dados foram coletados com 3,4 mil pessoas, de Norte a Sul do país. Para conferir os resultados completos, <a href="https://www.anbima.com.br/pt_br/especial/raio-x-do-investidor-2019.htm" target="_blank" className="text_link text_link--yellow">acesse nosso site</a>. A terceira edição, com números de 2019, foi preparada no final do ano e será divulgada em 2020.
													</p>
                          
                        </div>
                      </div>
                      <div className="card__image">
                        <img src={images.iniciativas.raio_x.capa} />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="perfil-investidor-body">

            <div className="container container--large">
              <div className="row">
								
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--no-border card--repercussao">
                      <div className="card__content card__content--full">

                        <div className="card__content__body">
													
													<div className="row" style={{position: 'inherit'}}>
														<div className="col-12">
                          		<h3 className="title title--small yellow">Repercussão na mídia</h3>
															<p>A pesquisa se consolidou na imprensa como referência em conhecimento sobre o investidor brasileiro. A segunda edição somou mais de 115 matérias jornalísticas publicadas: além de reportagens exclusivas no UOL e nas versões impressa e digital do Valor Econômico e d’O Estado de S.Paulo, os dados tiveram destaque em telejornais como Jornal Nacional e Jornal da Globo, e alcançaram repercussão regional em Alagoas, Espírito Santo, Piauí e Tocantins. </p>
														</div>
													</div>

                          <div className="row">
														<div className="col-4">
															<img src={images.iniciativas.raio_x.fim1} className="fim1" />
														</div>
														<div className="col-4">
															<img src={images.iniciativas.raio_x.fim2} className="fim2" />
														</div>
														<div className="col-4">
															<img src={images.iniciativas.raio_x.fim3} className="fim3" />
														</div>
													</div>

                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

              </div>
            </div>

          </section>

        </div>
      </div>
    );
  }
}

export { PerfilInvestidor };
